// extracted by mini-css-extract-plugin
module.exports = {"formBox":"FormBox_formBox_2BSeQ","heading":"FormBox_heading_2EAa8","lead":"FormBox_lead_28gmz","body":"FormBox_body__g8nE","footer":"FormBox_footer_79tD9"};